// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelIndex0 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/models/index.js';
import ModelKoiSeizesTreasure1 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/models/koiSeizesTreasure.js';
import ModelMyAwards2 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/models/myAwards.js';
import ModelPointShop3 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/models/pointShop.js';
import ModelTokenModal4 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/models/TokenModal.js';
import ModelIndex5 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/pages/MemberShipCenter/models/index.js';
import ModelIndex6 from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/src/pages/PostPaidC2C/models/index.js';
import dvaImmer, { enableES5, enableAllPlugins } from '/home/ZCIPClient/workpath/164805/code/code/promotion-frontend/promotionh5DXP/node_modules/dva-immer/dist/index.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  app.use(dvaImmer());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'index', ...ModelIndex0 });
app.model({ namespace: 'koiSeizesTreasure', ...ModelKoiSeizesTreasure1 });
app.model({ namespace: 'myAwards', ...ModelMyAwards2 });
app.model({ namespace: 'pointShop', ...ModelPointShop3 });
app.model({ namespace: 'TokenModal', ...ModelTokenModal4 });
app.model({ namespace: 'index', ...ModelIndex5 });
app.model({ namespace: 'index', ...ModelIndex6 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
